// extracted by mini-css-extract-plugin
export default {"root":"zx8Nq8QVmNNNrfVVFZwY","tableContainer":"SQqmYhz4ATSxwe8ZirO0"};